import { useQuery } from "@tanstack/react-query";
import { listWorkspaces, workspaceKeys } from "@rekonas/data-access";

export function useOperationalWorkspace() {
  const query = useQuery({ queryKey: workspaceKeys.all(), queryFn: ({ signal }) => listWorkspaces(signal) });
  const authorized = (query.data || []).filter((workspace) =>
    workspace.permissions.includes("operational_recordings.view"),
  );
  return { ...query, workspace: authorized.length === 1 ? authorized[0] : null, authorizedCount: authorized.length };
}
